// Разбор ответа POST /api/v1/admin/mlbb/automation/stages/{stageId}/start —
// массовый запуск автоматизации по матчам первых двух раундов стейджа.
//
// Бэкенд отдаёт в data запущенные этим вызовом матчи, а в meta — сводку:
// сколько запущено, какие матчи ждут соперника и какие были запущены раньше.

const STAGE_FORMAT_ERROR = 'Автоматизация доступна только для сетки Single Elimination'

function toCount(value) {
    return Array.isArray(value) ? value.length : 0
}

export function parseStageAutomationStart(response) {
    const payload = response?.data || {}
    const meta = payload.meta || {}
    const started = Array.isArray(payload.data) ? payload.data : []

    return {
        // started_count — источник правды, длина data нужна только как подстраховка
        startedCount: Number.isFinite(meta.started_count) ? meta.started_count : started.length,
        incompleteCount: toCount(meta.incomplete_group_ids),
        alreadyStartedCount: toCount(meta.already_started_group_ids),
        startedGroupIds: started.map(match => match?.group_id).filter(id => id != null),
        enabledAt: meta.automation_enabled_at || null
    }
}

export function stageAutomationStartMessage(result) {
    const parts = [`Запущено матчей: ${result.startedCount}`]

    if (result.incompleteCount) parts.push(`ждут соперника: ${result.incompleteCount}`)
    if (result.alreadyStartedCount) parts.push(`уже были запущены: ${result.alreadyStartedCount}`)

    return `${parts.join(', ')}.`
}

export function stageAutomationErrorMessage(error) {
    const status = error?.response?.status
    const serverMessage = error?.response?.data?.message

    if (status === 422) return serverMessage || STAGE_FORMAT_ERROR
    if (status === 404) return serverMessage || 'Этап не найден'
    if (status === 403) return serverMessage || 'У вашей роли нет доступа'

    return serverMessage || error?.message || 'Ошибка при запуске автоматизации'
}
